import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import DeleteIcon from "../../../assets/images/deleteIcon.svg";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomTextField from "../../CustomComponents/CustomTextField/CustomTextField";
import { useTranslation } from "react-i18next";
const styles = (theme) => ({});

const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function DeleteLicenseDialog(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [inputValue, setInputValue] = React.useState("");
    const [isInputValid, setIsInputValid] = React.useState(null);
    const [licenseNo, setLicenseNo] = React.useState('');
    const handleClose = (confirmDelete) => {
        setInputValue("");
        setIsInputValid(null);
        setOpen(false);
        props.dialogClose(confirmDelete);
    };

    React.useEffect(() => {
        let licenseNo = "";
        if (props.licenseNo && props.licenseNo.length) {
            licenseNo += props.licenseNo.toLowerCase().trim();
        }
        setLicenseNo(licenseNo);
    }, [props.licenseNo]);

    React.useEffect(() => {
        setOpen(props.dialogOpen);
    }, [props.dialogOpen]);

    React.useEffect(() => {
        if (inputValue && inputValue.length && licenseNo) {
            setIsInputValid(null);
            if (licenseNo.toLowerCase().replace(/ /g, "") === inputValue.toLowerCase().replace(/ /g, "")) {
                setIsInputValid(true);
            } else {
                setIsInputValid(false);
            }
        } else if (licenseNo === inputValue) {
            setIsInputValid(true);
        }
    }, [inputValue]);

    return (
        <CustomDialog
            onClose={() => handleClose(false)}
            aria-labelledby="customized-dialog-title"
            open={true}
            className={classes.dialogWrapper}
        >
            <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => handleClose(false)}
            >
                <CloseIcon />
            </IconButton>
            {/* <DialogTitle id="customized-dialog-title" onClose={handleClose} /> */}
            <DialogContent className={classes.dialogContentWrapper}>
                <CustomBox className={classes.dialogContentIcon}>
                    <img src={DeleteIcon} />
                </CustomBox>
                <Typography className={classes.dialogContentTitle}>
                    {t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_LICENSE")}
                </Typography>
                {licenseNo && licenseNo.length && <CustomTextField
                    className={classes.adminInput}
                    fullWidth
                    type="text"
                    label={`${t("LICENSE_NUMBER")} *`}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        disableUnderline: true,
                    }}
                    error={isInputValid === true ? false : true}
                    helperText={
                        isInputValid === false
                            ? t("LICENSE_NUMBER_YOU_ENTERED_DOESNT_MATCHED_WITH_EXISTING_LICENSE_NUMBER")
                            : null
                    }
                />}
            </DialogContent>
            <DialogActions className={classes.dialogActionWrapper}>
                <CustomButton
                    autoFocus
                    onClick={() => handleClose(false)}
                    color="primary"
                    className={classes.noBg}
                >
                    {t("CANCEL")}
                </CustomButton>
                <CustomButton
                    autoFocus
                    disabled={isInputValid !== true}
                    onClick={() => handleClose(true)}
                    variant="contained"
                    color="secondary"
                    defaultrounded="true"
                >
                    {t("DELETE_LICENSE")}
                </CustomButton>
            </DialogActions>
        </CustomDialog>
    );
}
